import type { AdminLogsFilters } from "@/features/admin/admin.types";

export function normalizeAdminLogsFilters(filters: AdminLogsFilters): AdminLogsFilters {
  return {
    ...filters,
    endDate: filters.endDate.trim(),
    page: Math.max(1, filters.page),
    searchText: filters.searchText.trim(),
    source: filters.source.trim(),
    startDate: filters.startDate.trim(),
  };
}

export function countActiveAdminLogFilters(filters: AdminLogsFilters) {
  let count = 0;

  if (filters.searchText.trim()) {
    count += 1;
  }

  if (filters.severity !== "all") {
    count += 1;
  }

  if (filters.source.trim()) {
    count += 1;
  }

  if (filters.startDate.trim()) {
    count += 1;
  }

  if (filters.endDate.trim()) {
    count += 1;
  }

  return count;
}
